import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { CdwRadioButtonModule } from '@cdw-ae/common-ui-components-radio-button';

import { CdwTreeComponent } from './cdw-tree/cdw-tree.component';

@NgModule({
  imports: [
    CommonModule,
    ScrollingModule,
    CdwIconModule,
    CdwCheckboxModule,
    CdwRadioButtonModule,
    MaterialLibraryModule,
  ],
  declarations: [CdwTreeComponent],
  exports: [CdwTreeComponent],
})
export class CdwTreeModule {}
